var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSadFritzLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.345,
    height: 56.356,
    viewBox: "0 0 40.345 56.356",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_800",
    "data-name": "Grupo 800",
    transform: "translate(-94.827 -8.822)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3564",
    "data-name": "Caminho 3564",
    d: "M670.9,525.9v7.655l5.653-2.739,5.688,2.739V525.9l-5.688,2.739Z",
    transform: "translate(-561.816 -468.377)",
    fill: "#7e59f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3565",
    "data-name": "Caminho 3565",
    d: "M667.766,406.231v-6.6a4.166,4.166,0,0,0-4.178-4.178h-15.2c-.211-.105-.386-.211-.562-.316a6.643,6.643,0,0,1-1.3-1.124,7.51,7.51,0,0,1-.983-1.369,20.708,20.708,0,0,1-.878-2.107c-.07-.211-.632-2.493-.737-2.879v-.07a.386.386,0,0,0-.772,0h0c-.035.07-.141.456-.281,1.018a18.884,18.884,0,0,0-.456,2.914,16.016,16.016,0,0,0,.246,2.142,10.159,10.159,0,0,0,.878,2.282,11.431,11.431,0,0,0,1.58,2.177c.211.211.421.421.667.632h0c-.211-.105-.386-.211-.6-.316a11.12,11.12,0,0,1-2.282-1.721,9.952,9.952,0,0,1-1.124-1.3h-5.653a4.166,4.166,0,0,0-4.178,4.178v9.867H630.3V413.5h1.018a9.225,9.225,0,0,0,17.908,2.6h2.493a9.257,9.257,0,0,0,8.673,6.145,9.42,9.42,0,0,0,9.235-8.743h1.018v-4.038h-2.879ZM640.588,418.24a5.344,5.344,0,0,1-5.162-4.705h10.358A5.41,5.41,0,0,1,640.588,418.24Zm10.955-8.743v2.212h-2.107V409.5H634.9l1.37-6.531,1.9,2.142,2.388-4.038H659.2l2.388,4.038,1.9-2.142,1.37,6.531Zm8.849,8.743a5.379,5.379,0,0,1-5.2-4.705h10.358A5.32,5.32,0,0,1,660.392,418.24Z",
    transform: "translate(-535.473 -378.378)",
    fill: "#7e59f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3566",
    "data-name": "Caminho 3566",
    d: "M695.772,499.957a1.03,1.03,0,0,1-1.159-.878,3.886,3.886,0,0,0-1.159-2.212,3.786,3.786,0,0,0-2.739-1.053,3.844,3.844,0,0,0-2.669,1.194,1.018,1.018,0,1,1-1.475-1.4,5.865,5.865,0,0,1,4.108-1.826h.141a5.77,5.77,0,0,1,4.038,1.615,5.829,5.829,0,0,1,1.756,3.406A1.031,1.031,0,0,1,695.772,499.957Z",
    transform: "translate(-571.801 -447.533)",
    fill: "#7e59f2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadFritzLogo);
export default __webpack_public_path__ + "static/media/sad_fritz_logo.7bbd2f19aa8d3b6b6351cc96247543b1.svg";
export { ForwardRef as ReactComponent };